import { render, staticRenderFns } from "./WysiwygEditor.vue?vue&type=template&id=0f3b0641&scoped=true&"
import script from "./WysiwygEditor.vue?vue&type=script&lang=js&"
export * from "./WysiwygEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3b0641",
  null
  
)

export default component.exports